import { RebuildRouteTypeEnum, RouteRebuildSourceEnum } from "../enums";

export const REBUILD_TYPE_TRANSLATION_KEY_MAP: Record<
  RebuildRouteTypeEnum,
  string
> = {
  [RebuildRouteTypeEnum.Default]: "general.REBUILD_ROUTE_DEFAULT",
  [RebuildRouteTypeEnum.RefreshCache]: "general.REBUILD_REFRESH_CACHE",
  [RebuildRouteTypeEnum.SkipCacheWithoutUpdate]:
    "general.REBUILD_ROUTE_SKIP_CACHE",
  [RebuildRouteTypeEnum.ProviderOptimization]: "general.PROVIDER_OPTIMIZATION",
  [RebuildRouteTypeEnum.BestFit]: "general.REBUILD_BEST_FIT",
  [RebuildRouteTypeEnum.OptimizeStationOrderOsrmFirst]:
    "general.OPTIMIZE_STATIONS_ORDER",
  [RebuildRouteTypeEnum.KeepOrder]: "general.REBUILD_KEEP_ORDER",
  [RebuildRouteTypeEnum.EndpointsLocked]: "general.REBUILD_ENDPOINTS_LOCKED",
};

export const ROUTE_REBUILD_SOURCE_TRANSLATION_KEY_MAP: Record<
  RouteRebuildSourceEnum,
  string
> = {
  [RouteRebuildSourceEnum.FromCache]: "general.ROUTE_REBUILD_SOURCE_FROM_CACHE",
  [RouteRebuildSourceEnum.FromMlPath]:
    "general.ROUTE_REBUILD_SOURCE_FROM_ML_PATH",
  [RouteRebuildSourceEnum.LiveWithoutCache]:
    "general.ROUTE_REBUILD_SOURCE_LIVE_WITHOUT_CACHE",
  [RouteRebuildSourceEnum.LiveCacheUpdated]:
    "general.ROUTE_REBUILD_SOURCE_LIVE_CACHE_UPDATED",
};
